/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineIdLangsCulture202,
  DeleteApiV1ClassroomdisciplineIdLangsCulture401,
  DeleteApiV1ClassroomdisciplineIdLangsCulture404,
  DeleteApiV1ClassroomdisciplineIdLangsCultureMutationResponse,
  DeleteApiV1ClassroomdisciplineIdLangsCulturePathParams,
} from "../../types/classPlanningLangController/DeleteApiV1ClassroomdisciplineIdLangsCulture.ts";

export const deleteApiV1ClassroomdisciplineIdLangsCulturePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    culture: z.string(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdLangsCulturePathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineIdLangsCulture202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdLangsCulture202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineIdLangsCulture401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdLangsCulture401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineIdLangsCulture404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdLangsCulture404>;

export const deleteApiV1ClassroomdisciplineIdLangsCultureMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineIdLangsCulture202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdLangsCultureMutationResponse>;
